import {DialogContentText, Typography} from "@mui/material";
import i18next from "i18next";
import React from "react";
import useStyles from "../style/js-style/components/FeedBackPopUpStyle";
import clsx from "clsx";
import EAColorIcon from './common/EAColorIcon';

function FeedBackPopUp({
   onClick,
   title = false,
   imgSrc,
   isMultipleAttributesSelected,
   variant= "grey",
   content = false,
   imgSize = "regular",
   ...othersProps
}) {
  const { classes } = useStyles();

  const getIconClass = (variant) => {
    return variant === "valid"
      ? classes.feedBackContentValid
      : variant === "grey"
        ? classes.feedBackContentGrey
        : classes.feedBackContent
  }

  return (
    <DialogContentText
      component={"div"}
      className={classes.feedBackWrapper}
      {...othersProps}
    >
      {/* Title + cross to close */}
      {title ? (
        <>
          <img
            src={process.env.PUBLIC_URL +  "/img/icons/cross.svg"}
            alt="cross"
            onClick={onClick}
            className={classes.feedBackCross}
          />
          <Typography variant={"h2"} className={classes.feedBackTitle}> {title} </Typography>
        </>
      ) : "" }

      {/* Main content */}
      <div className={classes.feedBackMessageWrapper}>
        <div>
          {/* Icon */}
          <span className={ clsx(classes.feedBackContentGeneral, getIconClass(variant))}>
            <EAColorIcon
              icon={imgSrc}
              svgStyle={{position: 'relative', top: "2px"}}
              width={imgSize === "regular" ? "20px" : "15px"}
            />
          </span>
        </div>
        <div>

        {/* Message */}
          <span className={classes.contentMessage}>
            {content
              ? content
              : isMultipleAttributesSelected
              ? `${i18next.t("attributes.deletedMultiInfo")} `
              : `${i18next.t("attributes.deletedSingleInfo")}`
            }
        </span>
        </div>
      </div>
    </DialogContentText>
  );
}

export default FeedBackPopUp;
